export default "__VITE_ASSET__74e07ba1__"